<template>
  <div class="prescription">
    <div class="cont">
      <div class="eraSelect bgWhite">
        <div class="searchBox">
          <div class="selfInput">
            <el-input clearable
              v-model="keyword" placeholder="请输入关键字搜索" 
              @change="searchFn" @keyup.enter="searchFn"
              prefix-icon="el-icon-search"
            ></el-input>
          </div> 
          <el-button class="select-checked" size="mini">搜索</el-button>
        </div>
        <div class="eralist">
          <span class="text">选择年代：</span>
          <span class="btns" :class="{active:item.id==actYearId}" v-for="item in eraList" :key="item.id" @click="getYearsData(item)">{{item.name}}</span> 
        </div>
      </div>
      <span class="tips" v-if="actYearId">{{ actYear.name }}：</span>
      <div class="listsBox bgWhite">
        <ul class="lists">
          <li class="item" v-for="item in zhongcaoyaoList" :key="item.id" @click="zhongcaoyaoD(item.id)">
            <p class="info1">
              <span class="nameT">{{ item.rectificationName }}</span>
              <span class="year">{{ item.years }}</span>
            </p>
            <p class="info2">
              {{ item.source }}{{ item.section }}
            </p>
          </li>
        </ul>
        <div class="pages">
          <el-pagination
            background
            layout="total,prev, pager, next,jumper"
            :total="pageInfo.total"
            :page-size="pageInfo.pageSize"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div> 
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data(){
    return {
      keyword:'',
      actYearId:'',
      actYear:{},
      eraList:[],
      pageInfo:{
        pageNum:1,
        pageSize:32,
        total:0
      },
      zhongcaoyaoList:[]
    }
  },
  created() {
    this.getYears()
    this.getData()
  },
  methods:{
    getYears(){
      let url = "/years/parent/getYearsList"; 
      this.eraList = []
      this.$http
        .post(url,{})
        .then(res => {
          if(res.data.code == 200){
            this.eraList = res.data.data
          } 
        })
    },
    getYearsData(data){ 
      if(this.actYearId == data.id){
        this.actYearId = '' 
        this.actYear = {}
      }else{
        this.actYearId = data.id
        this.actYear = data
      }
      this.getData()
    },
    getData(){
      let param = {
        years:this.actYearId,
        pageNum: this.pageInfo.pageNum,
        pageSize:this.pageInfo.pageSize,
        rectificationName:this.keyword
      } 
      let url = "/ancientPrescription/pageAncientPrescriptionMoreYears"; 
      axios.post(url, param)
        .then(res => {
          if (res.data.code == 200) {
            this.pageInfo.total = res.data.data.total;
            this.pageInfo.pageSize = res.data.data.pageSize;
            this.zhongcaoyaoList = res.data.data.list
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.$message.error("网络错误！");
        });
    },
    searchFn(){
      this.pageInfo.pageNum = 1 
      this.getData()
    },
    //选页
    handleCurrentChange(v) { 
      this.pageInfo.pageNum = v; //当前页
      this.getData();
    },
    //中草药详情
    zhongcaoyaoD(id) {
      this.$router.push({
        path: "/ancPreDetail",
        query: { id: id }
      });
    },
  },
}
</script>
<style scoped>
.prescription{
  background: #F9F9F9;
  padding: 10px 0;
}
.bgWhite{
  background: #fff;
  border-radius:4px;
  border: 1px solid #F0F0F0;
  padding: 20px;
}
.cont{
  width: 1024px;
  margin: 0 auto;
}
.searchBox{
  display: flex;
}
.selfInput{
  width: 342px;
  margin-right: 10px;
}

/deep/.selfInput .el-input__inner{
  height: 34px;
  line-height: 34px;
  background: #f4f5f5;
}
/deep/.selfInput .el-input__icon{
  line-height: 34px;
}
/deep/.selfInput .el-input.is-active .el-input__inner{
  border-color:#f64420;
}
/deep/.selfInput .el-input__inner:focus{
  border-color:#f64420;
}
.eralist {
  margin-top: 20px;
  display: flex;  
  flex-wrap: wrap;
  margin-bottom: -10px;
}
.eralist .text{
  font-weight: bold;
  font-size: 14px;
  line-height: 25px;
  color: #050505;
}
.eralist .btns{
  padding: 0 12px;
  border-radius: 4px  ;
  border: 1px solid rgba(153,153,153,0.28);
  background-color: #fff;
  font-size: 14px;
  line-height: 25px;
  color: #999;
  margin-right: 10px;
  cursor: pointer;
  margin-bottom: 10px;
  transition: .3s all ease;
} 
.eralist .btns.active,
.eralist .btns:hover{
  background: #F64420;  
  color:#fff;
}
.tips{
  font-size: 16px;
  color: #666;
  margin-top: 10px;
  display: block;
  padding-left: 10px;
}
.listsBox{
  margin-top: 10px;
}
.lists{
  display: flex;
  flex-wrap: wrap;
  margin:-10px;
}
.item{
  background: rgba(243,245,249,0.5);
  border-radius: 4px 4px 4px 4px;
  border: 1px dashed #D7D7D7;
  padding: 10px;
  box-sizing: border-box;
  margin:10px;
  width: calc(25% - 20px);
  transition: .3s all ease;
  cursor: pointer;
}
.item:hover{
  background: rgba(246,68,32,0.03);
  box-shadow: 0px 4px 15px -6px rgba(0,0,0,0.16);
}
.info1{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}
.info1 .nameT{
  font-size: 16px;
  color: #333;
}
.info1 .nameT:hover{
  color:#f64420;
}
.info1 .year,
.info2{
  font-size: 14px;
  color: #999;
} 
</style>


// WEBPACK FOOTER //
// src/components/ancPre.vue